import { render, staticRenderFns } from "./zhuxiao2.vue?vue&type=template&id=0c96b5e2&scoped=true&"
import script from "./zhuxiao2.vue?vue&type=script&lang=js&"
export * from "./zhuxiao2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96b5e2",
  null
  
)

export default component.exports